// extracted by mini-css-extract-plugin
export default {"servicesColourSections":"Services_servicesColourSections__Nkvcz","servicesWrapper":"Services_servicesWrapper__uNAV2","serviceCategory":"Services_serviceCategory__78bMM"};